import dateFormatter from '@/libs/formatter/dateFormatter'
import priceFormatter from '@/libs/formatter/priceFormatter'

export default {
  ...dateFormatter,
  ...priceFormatter,
}
